import { z } from 'zod'

export const authPasswordSchema = z.object({
  company: z.string().min(1, 'Empresa é obrigatória'),
  password: z.string().min(1, 'Senha é obrigatória'),
})

export type AuthPasswordSchema = z.infer<typeof authPasswordSchema>